module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy1--dark-2ed71fa48333bd1d68efb12595ff6066.svg";